import React from "react";

/**
 * Picks the best image variant per viewport via `srcset` + `sizes`.
 * Expects sibling files at `*-sm.jpg` (800w) and `*-md.jpg` (1200w) next to the original (full).
 *
 * src        = full-size original (used as the largest candidate + fallback)
 * sizes      = standard `sizes` attribute. Default: 100vw on mobile, 33vw on desktop.
 */
export default function ResponsiveImg({
  src,
  alt,
  className,
  sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw",
  loading = "lazy",
  decoding = "async",
  ...rest
}) {
  if (!src) return null;
  const dot = src.lastIndexOf(".");
  if (dot === -1) {
    return (
      <img src={src} alt={alt} className={className} loading={loading} decoding={decoding} {...rest} />
    );
  }
  const base = src.slice(0, dot);
  const ext = src.slice(dot);
  const sm = `${base}-sm${ext}`;
  const md = `${base}-md${ext}`;
  const srcSet = `${sm} 800w, ${md} 1200w, ${src} 1800w`;
  return (
    <img
      src={sm}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      className={className}
      loading={loading}
      decoding={decoding}
      {...rest}
    />
  );
}
